// Inspiration from here: https://observablehq.com/@d3/kernel-density-estimation

const kernelEpanechnikov = (k) => {
  return function(v) {
    return Math.abs(v /= k) <= 1 ? 0.75 * (1 - v * v) / k : 0;
  };
}

export default kernelEpanechnikov;
